// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-knowledge-modal-s_tp8K .semi-modal-content{max-height:calc(100vh - 100px)!important}.import-unit-type-label-shvq9a{margin-bottom:8px;font-size:14px;font-weight:700;line-height:20px;display:block}.create-form-XtljLk .semi-form-field{padding-top:0;padding-bottom:24px!important}.create-form-XtljLk .semi-form-field-label{color:var(--coz-fg-secondary);margin-bottom:0;padding:0 8px 6px;font-size:12px;font-style:normal;font-weight:500;line-height:16px}.upload-avatar-container-SsJ1qa{width:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create-knowledge-modal": `create-knowledge-modal-s_tp8K`,
	"createKnowledgeModal": `create-knowledge-modal-s_tp8K`,
	"import-unit-type-label": `import-unit-type-label-shvq9a`,
	"importUnitTypeLabel": `import-unit-type-label-shvq9a`,
	"create-form": `create-form-XtljLk`,
	"createForm": `create-form-XtljLk`,
	"upload-avatar-container": `upload-avatar-container-SsJ1qa`,
	"uploadAvatarContainer": `upload-avatar-container-SsJ1qa`
};
export default ___CSS_LOADER_EXPORT___;
